import React from 'react'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { ToolTipWrapper, TOP_TIP_POSITION } from '../tooltip'
import InfoIcon from './infoIcon.inline.svg'
import styles from './productTraditionalDiscountMessage.module.scss'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'

export interface ProductTraditionalDiscountMessageProps {
  formattedTraditionalPrice?: string
  traditionalDiscountMessage?: string
}

const ProductTraditionalDiscountMessage = ({
  formattedTraditionalPrice,
  traditionalDiscountMessage,
}: ProductTraditionalDiscountMessageProps) => {
  const { deviceType } = useDeviceInfo()
  const isDesktop = deviceType === DEVICE_TYPES.DESKTOP
  return (
    <>
      {!formattedTraditionalPrice && traditionalDiscountMessage && (
        <div className={styles.traditionalDiscountTextWrapper}>
          <div
            dangerouslySetInnerHTML={{
              __html: getSanitizedHtml(traditionalDiscountMessage),
            }}
          ></div>
          <ToolTipWrapper
            topTipPosition={isDesktop ? TOP_TIP_POSITION.TOP : TOP_TIP_POSITION.BOTTOM}
            className={styles.infoIcon}
            toolTipContentRenderer={() =>
              'Your credit will appear in your Store Credit Balance once your purchase is complete. You must create a Quince account in order to earn credit.'
            }
            toolTipContentClassName={styles.toolTipContentWrapper}
          >
            <InfoIcon />
          </ToolTipWrapper>
        </div>
      )}
    </>
  )
}

export default ProductTraditionalDiscountMessage
